import { useMemo, useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

// Functions
import remToPx from '../../../functions/rem-to-px';

// Context
import { FormContext } from '../context/form-context';
import { useGlobalState } from '../../../utilities/global-state'

export const FormFeedback = ({ data, customValidationErrors, displayFormValidation, genericValidationMessage, scrollOffset = 2, focusOnMessage, className = '', inGrid = false, show = ['error', 'info', 'success'] }) => {
	const { touched: parentFormTouched, validationErrors: parentFormValidationErrors, submissionCount: formSubmissionCount } = useContext(FormContext);
  const { topViewportOffset } = useGlobalState();
	const containerRef = useRef();

	const { message, mode } = useMemo(() => {
		let message = false;
		let mode = 'error';

		if(typeof data === 'string') {
			message = data;
		}
		else if(data) {
			for(const type of show) {
				if(data[type] && data[type].length) {
					message = typeof(data[type]) === 'string' ? data[type] : data[type].join(',');
					mode = type;
					break;
				}
			}
		}
		else {
			let newMessages = [];

			if(customValidationErrors && customValidationErrors.length) {
				newMessages = [...newMessages, ...customValidationErrors];
			}
			if(displayFormValidation && parentFormTouched && parentFormValidationErrors.length) {
				newMessages = [...newMessages, ...(genericValidationMessage ? [genericValidationMessage] : parentFormValidationErrors)];
			}

			if(newMessages.length) {
				message = `<p>${newMessages.join('</p><p>')}</p>`;
			}
		}

		return { message, mode };
	}, [customValidationErrors, displayFormValidation, data, show, parentFormTouched, parentFormValidationErrors, genericValidationMessage])

	useEffect(() => {
		if(focusOnMessage && message?.length && containerRef?.current) {
      const [container, offset] = (() => {
        var response = [window, window.scrollY];
        
        document.querySelectorAll('.modal-container.show').forEach((modal) => {
          if(modal.contains(containerRef.current)) {
            const wrapper = modal.querySelector('.modal-innerwrap');
            response = [wrapper, wrapper.scrollTop];
            return;
          }
        })

        return response;
      })();

			container.scrollTo({
				top: containerRef.current.getBoundingClientRect().top + offset - remToPx(scrollOffset) - (topViewportOffset ?? 0),
				left: 0,
				behavior: "smooth",
			})
		}
	}, [focusOnMessage, message, scrollOffset, topViewportOffset, formSubmissionCount])

	if (message) {
		if(inGrid) {
			return (
				<div className="row">
					<div className="col">
						<div ref={containerRef} className={'form-feedback ' + mode + ' ' + className} dangerouslySetInnerHTML={{__html: message}} />
					</div>
				</div>
			)
		}
		else {
			return (
				<>
					<div ref={containerRef} className={'form-feedback ' + mode + ' ' + className} dangerouslySetInnerHTML={{__html: message}} />
				</>
			)
		}
	}
	else { return null; }
}

FormFeedback.propTypes = {
	data: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.oneOf([false, null])]),
	customValidationErrors: PropTypes.arrayOf(PropTypes.string),
	displayFormValidation: PropTypes.bool,
	genericValidationMessage: PropTypes.string,
	focusOnMessage: PropTypes.bool,
	className: PropTypes.string,
	inGrid: PropTypes.bool,
  scrollOffset: PropTypes.number,
	show: PropTypes.arrayOf(PropTypes.oneOf(['error', 'info', 'success'])),

}